export { HourGlass as default } from './HourGlass';
